
import { find, findAll } from "../utils/dom";

import Swiper from "swiper";


const PageAgendamentoEvento = () =>{
	const page = find(`[js-page='agendamento-evento']`);
	if(!page) return;




	const $ = {
		buttonItemGrid: findAll("[js-button-agenda-eventos]")
	}

	const swiperItemAgendamento = new Swiper('.swiper-items-contato-agendamento', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			breakpoints: {
					767: { spaceBetween: 48 }
			},
	});

	const swiperGridImages = new Swiper('.swiper-grid-images', {
			slidesPerView: 1,
			navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
			},
			pagination: {
					el: '.swiper-pagination',
			},
	});

	// Função para atualizar o botão ativo
	function updateActiveButton(index) {
			const buttons = document.querySelectorAll('[js-button-agenda-eventos]');
			buttons.forEach((button) => {
					button.classList.remove('active');
			});

			const activeButton = document.querySelector(`[js-button-agenda-eventos="${index}"]`);
			if (activeButton) {
					activeButton.classList.add('active');
			}
	}

	// Sincronizar o swiper-grid-images com os botões do swiper-items-contato-agendamento
	swiperGridImages.on('slideChange', () => {
			const activeIndex = swiperGridImages.activeIndex;
			updateActiveButton(activeIndex);
	});
	
	function resetActive(){
		$.buttonItemGrid?.forEach((item)=>{
			item.classList.remove("active");
		})
	}

	$.buttonItemGrid?.forEach((item)=>{
		item.addEventListener("click",(e) => {
			const id = e.target.getAttribute("js-button-agenda-eventos");
			if(!id) return;

			swiperGridImages.slideTo(id);
			resetActive()
			e.target.classList.add("active");
		})
	})


}

export default PageAgendamentoEvento;